<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('successes.Header') }}</h2>
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <kendo-tabstrip>
                <ul>
                    <li class="k-state-active">
                        {{ $t('successes.TabPoomsae') }}
                    </li>
                    <li>
                        {{ $t('successes.TabSparring') }}
                    </li>
                </ul>
                <div>
                    <div id="gridSuccessesPoomsae">

                    </div>
                </div>
                <div>
                    <div id="gridSuccessesSparring">

                    </div>
                </div>
            </kendo-tabstrip>
        </div>
    </div>
</template>

<script type="text/javascript">
    import $ from 'jquery';
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import { TabStrip } from '@progress/kendo-layout-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource,
            'kendo-tabstrip': TabStrip
        },
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
                return {
                    theImage: '',
                }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
            this.initGridSuccessesPoomsae();
            this.initGridSuccessesSparring();
            const grid = this.$refs.grid.kendoWidget();
            $.each(grid.columns, function (index, column) {
                grid.resizeColumn(column, column.minResizableWidth);
            });

        },
        created() {
            
        },
        methods: {
            initGridSuccessesPoomsae() {
                const url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/ErfolgeTurniereFormen";
                var GridSuccessesPoomsae = $("#gridSuccessesPoomsae").kendoGrid({
                    dataSource: {
                        transport: {
                            read: {
                                url: url,
                                dataType: 'jsonp'
                            }
                        },
                        schemaModelFields: {
                            Turnier: { validation: { required: true } },
                            Ort: { validation: { required: true } },
                            Wertung: { validation: { required: true } },
                            Platz1: { type: 'number', editable: false },
                            Platz2: { type: 'number', editable: false },
                            Platz3: { type: 'number', editable: false },
                            Graduierungen: { validation: { required: false } }
                        }
                    },
                    columns: [
                        { field: "Turnier", title: this.$t('successes.GridColumnHeaderTournament'), minResizableWidth: 350 },
                        { field: "Ort", title: this.$t('successes.GridColumnHeaderLocation'), minResizableWidth: 150 },
                        { field: "Wertung", title: this.$t('successes.GridColumnHeaderScore'), minResizableWidth: 150 },
                        { field: "Platz1", title: this.$t('successes.GridColumnHeaderRank1') },
                        { field: "Platz2", title: this.$t('successes.GridColumnHeaderRank2') },
                        { field: "Platz3", title: this.$t('successes.GridColumnHeaderRank3') },
                    ],
                    toolbar: ['pdf'],
                    mobile: true,
                    pdf: {
                        fileName: this.$t('successes.PDFExportNamePoomsae'),
                        allPages: true,
                        landscape: true,
                        paperSize: "A4",
                        repeatHeaders: true
                    }
                }).data("kendoGrid");
                GridSuccessesPoomsae.Resize;
                GridSuccessesPoomsae.autoFitColumn(0);
                GridSuccessesPoomsae.autoFitColumn(1);
                GridSuccessesPoomsae.autoFitColumn(2);
                GridSuccessesPoomsae.autoFitColumn(3);
                GridSuccessesPoomsae.autoFitColumn(4);
                GridSuccessesPoomsae.autoFitColumn(5);
            },
            initGridSuccessesSparring() {
                const url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/ErfolgeTurniereKampf";
                var GridSuccessesSparring = $("#gridSuccessesSparring").kendoGrid({
                    dataSource: {
                        transport: {
                            read: {
                                url: url,
                                dataType: 'jsonp'
                            }
                        },
                        schemaModelFields: {
                            Turnier: { validation: { required: true } },
                            Ort: { validation: { required: true } },
                            Wertung: { validation: { required: true } },
                            Platz1: { type: 'number', editable: false },
                            Platz2: { type: 'number', editable: false },
                            Platz3: { type: 'number', editable: false },
                            Graduierungen: { validation: { required: true } }
                        }
                    },
                    columns: [
                        { field: "Turnier", title: this.$t('successes.GridColumnHeaderTournament'), minResizableWidth: 350 },
                        { field: "Ort", title: this.$t('successes.GridColumnHeaderLocation'), minResizableWidth: 150 },
                        { field: "Wertung", title: this.$t('successes.GridColumnHeaderScore'), minResizableWidth: 150 },
                        { field: "Platz1", title: this.$t('successes.GridColumnHeaderRank1'), minResizableWidth: 100 },
                        { field: "Platz2", title: this.$t('successes.GridColumnHeaderRank2'), minResizableWidth: 100 },
                        { field: "Platz3", title: this.$t('successes.GridColumnHeaderRank3'), minResizableWidth: 100 },
                        { field: "Graduierungen", title: this.$t('successes.GridColumnHeaderGraduations'), minResizableWidth: 250 },
                    ],
                    toolbar: ['pdf'],
                    mobile: true,
                    pdf: {
                        fileName: this.$t('successes.PDFExportNameSparring'), 
                        allPages: true,
                        landscape: true,
                        paperSize: "A4",
                        repeatHeaders: true
                    }
                }).data("kendoGrid");
                GridSuccessesSparring.Resize;
                GridSuccessesSparring.autoFitColumn(0);
                GridSuccessesSparring.autoFitColumn(1);
                GridSuccessesSparring.autoFitColumn(2);
                GridSuccessesSparring.autoFitColumn(3);
                GridSuccessesSparring.autoFitColumn(4);
                GridSuccessesSparring.autoFitColumn(5);
                GridSuccessesSparring.autoFitColumn(6);
            }
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>